import PropTypes from 'prop-types';
import { BulkFulfillmentPlanTypeEnum } from '../enums/bulk-fulfillment-plan-type';
import { ShippingServicePropType } from '../prop-types/shipping-service';

const bulkFulfillmentPlanTypeNames = Object.values(BulkFulfillmentPlanTypeEnum);

export const BulkJobDataPropType = PropTypes.shape({
  fulfillmentPlanCount: PropTypes.number,
  services: PropTypes.arrayOf(ShippingServicePropType),
  bulkFulfillmentPlanType: PropTypes.oneOf(bulkFulfillmentPlanTypeNames),
  bulkUpdateJobId: PropTypes.string,
});

/**
 * @typedef {object} BulkJobDataPropType
 * @property {number} fulfillmentPlanCount
 * @property {ShippingServicePropType[]} services
 * @property {'Mixed'|'International'|'Domestic'} bulkFulfillmentPlanType
 * @property {string} bulkUpdateJobId
 */
